import { FetchUserHQLocationDashBoard } from "../../../domain/useages/user-hq-location-dashboard/fetch-user-hq-location-dashboard";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpGetClient } from "../../protocols/http/http-get-client";

export class RemoteUserHQLocationDashBoard implements FetchUserHQLocationDashBoard {
  constructor(
    private readonly url: string,
    private readonly httpGetClient: HttpGetClient
  ) {}

  async fetch(params: FetchUserHQLocationDashBoard.Params): Promise<any> {
    const httpResponse = await this.httpGetClient.get({
      url: this.url,
      query: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    }
  }
}
